import React from 'react';
import { FormikTextInput } from 'src/common/form/formik/text-input';

const ShareCompanyNameInput = (props: { value: string, onChange: (e:React.ChangeEvent<string>) => void, disabled: boolean, mergeField?: string | undefined | null }) => {
  return (
    <div className='flex flex-col space-y-2 pb-6'>
      <FormikTextInput
        maxLength={50}
        hideCharacterCount
        id='journey-share-alias-form-company-name'
        name='hubspot_company_name'
        label='Company Name'
        placeholder='Company Name'
        type='text'
        autoComplete='off'
        autoCapitalize='off'
        autoCorrect='off'
        spellCheck='false'
        onChange={props.onChange}
        mergeField={props.mergeField}
        value={props.value}
        disabled={props.disabled}
      />
    </div>
  );
};

export default ShareCompanyNameInput;
